import { IFormService } from "../../service/form/FormService";

export default class UndoRowDeleteInteractor {
  private formService: IFormService;

  constructor(formService) {
    this.formService = formService;
  }

  async execute(qualifierId: number) {
    await this.formService.deleteRow(qualifierId);
  }
}
